

import React, { memo } from 'react';
import cx from 'classnames';
import Input from '../../Input';

import {
  INPUTS_CONTAINER,
  MANUAL_LOCATION_FORM,
  STREET_INPUTS_CONTAINER,
  COUNTRY_INPUTS_CONTAINER } from
'../styles/manualLocationForm';

const defaultedValue = (value) => value || '';







function ManualLocationForm(
{ address, onChangeAddressField, disabled })
{
  const { country, state, street, unit, postCode, citySuburb } = address;

  return (
    <div className={MANUAL_LOCATION_FORM}>
      <div className={cx(INPUTS_CONTAINER, STREET_INPUTS_CONTAINER)}>
        <Input
          id="unit"
          label="Unit/Level/Suite"
          defaultValue={defaultedValue(unit)}
          onChange={onChangeAddressField('unit')}
          disabled={disabled} />

        <Input
          id="street-address"
          label="Street Address"
          labelProps={{ required: true }}
          defaultValue={defaultedValue(street)}
          onChange={onChangeAddressField('street')}
          disabled={disabled} />

      </div>
      <div className={cx(INPUTS_CONTAINER, COUNTRY_INPUTS_CONTAINER)}>
        <Input
          id="city"
          label="City/Suburb"
          labelProps={{ required: true }}
          defaultValue={defaultedValue(citySuburb)}
          onChange={onChangeAddressField('citySuburb')}
          disabled={disabled} />

        <Input
          id="state"
          label="State"
          labelProps={{ required: true }}
          defaultValue={defaultedValue(state)}
          onChange={onChangeAddressField('state')}
          disabled={disabled} />

        <Input
          id="postal-code"
          label="Postal/Zip Code"
          labelProps={{ required: true }}
          defaultValue={defaultedValue(postCode)}
          onChange={onChangeAddressField('postCode')}
          disabled={disabled}
          maxlength={10} />

      </div>
      <Input
        id="country-input"
        label="Country"
        labelProps={{ required: true }}
        defaultValue={defaultedValue(country)}
        onChange={onChangeAddressField('country')}
        disabled={disabled} />

    </div>);

}

export default memo(ManualLocationForm);